import React, { useState } from 'react';

import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '../../core-ui';

import CheckboxList from './CheckboxList';

const defaultLabelRenderer = (item: unknown) => String(item);

type Props<T> = {
  title: string;
  items: Iterable<T>;
  renderLabel?: (item: T) => string;
  submitButtonText: string;
  onSubmit: (selectedItems: Set<T>) => void;
};

export default function CheckboxListModal<T>(props: Props<T>) {
  const { title, submitButtonText, items, renderLabel, onSubmit } = props;

  const [isOpen, setOpen] = useState(false);

  const [selectedItems, setSelectedItems] = useState(() => new Set<T>());

  return (
    <>
      <Button onClick={() => setOpen(true)}>{title}</Button>
      <Modal isOpen={isOpen} onClose={() => setOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <CheckboxList
              items={items}
              selectedItems={selectedItems}
              renderLabel={renderLabel ?? defaultLabelRenderer}
              onSelectionChange={(newSelectedItems) => {
                setSelectedItems(newSelectedItems);
              }}
            />
          </ModalBody>
          <ModalFooter>
            <HStack spacing={2}>
              <Button onClick={() => setSelectedItems(new Set())}>
                {t('Reset')}
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  onSubmit(selectedItems);
                  setOpen(false);
                }}
              >
                {submitButtonText}
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
